import type { FunctionComponent, PropsWithChildren } from "react"

import dynamic from "next/dynamic"

import { CheckCdnAccess } from "@/modules/JobteaserCdn/CheckCdnAccess"
import { FoLayoutContext } from "@/modules/layouts/contexts/foLayout"
import { useFoLayoutState } from "@/modules/layouts/hooks/useFoLayoutState"

export type FoLayoutProps = PropsWithChildren<{
  host: string
  className?: string
}>

const HeaderDynamic = dynamic(() => import("@/modules/headerFooterFO/Header").then(mod => mod.Header))
const FooterDynamic = dynamic(() => import("@/modules/headerFooterFO/Footer/Footer").then(mod => mod.Footer))

export const FoLayout: FunctionComponent<FoLayoutProps> = ({ children, className, host }) => {
  const layoutState = useFoLayoutState(host)
  const { allowedLocales, isHeaderNeeded, isFooterNeeded } = layoutState

  return (
    <FoLayoutContext.Provider value={layoutState}>
      {isHeaderNeeded() && <HeaderDynamic />}
      <main className={className}>{children}</main>
      {isFooterNeeded() && <FooterDynamic pageTranslations={allowedLocales} />}
      <CheckCdnAccess />
    </FoLayoutContext.Provider>
  )
}
